import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule, MatButtonModule, MatProgressSpinnerModule } from '@angular/material';
import { PdfViewerPageComponent } from './pdf-viewer-page.component';
import { SafePipe } from './safe.pipe';

@NgModule({
  declarations: [PdfViewerPageComponent, SafePipe],
  imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule],
  exports: [PdfViewerPageComponent, SafePipe]
})
export class PdfViewerPageModule {}
